import { Person } from '@/analysis/types';
import api from '@/API';
import eventBus from '@/messaging/event-bus';
import {
  PersonCreated, PersonTrashed, PersonRestored, PersonMerged,
} from '@/messaging/events';

export interface CreatePersonPayload {
  label?: string;
  faceId?: number;
}

export interface UpdatePersonPayload {
  label?: string;
  primaryFaceId?: number;
}

export interface MergePersonsPayload {
  targetPersonId: number;
  sourcePersonIds: number[];
}

export function create(clientId: number, data: CreatePersonPayload): Promise<Person> {
  return api.post(`clients/${clientId}/persons`, data).then((response) => {
    const person = response.data;
    eventBus.$emit(PersonCreated.eventName, new PersonCreated(person));
    return person;
  });
}

export function update(personId: number, data: UpdatePersonPayload): Promise<Person> {
  return api.put(`/persons/${personId}`, data).then(response => response.data);
}

export function merge(data: MergePersonsPayload): Promise<Person> {
  return api.post('/persons/merge', data).then((response) => {
    const person = response.data;
    eventBus.$emit(PersonMerged.eventName, new PersonMerged(person, data.sourcePersonIds));
    return person;
  });
}

export function trash(personId: number): Promise<Person> {
  return api.post(`/persons/${personId}/trash`).then((response) => {
    const person = response.data;
    eventBus.$emit(PersonTrashed.eventName, new PersonTrashed(person));
    return person;
  });
}

export function restore(personId: number): Promise<Person> {
  return api.post(`/persons/${personId}/restore`).then((response) => {
    const person = response.data;
    eventBus.$emit(PersonRestored.eventName, new PersonRestored(person));
    return person;
  });
}
